class CollectionDescription extends HTMLElement {
  MAX_LENGTH = 500;
  SHOW_MORE = true;
  constructor() {
    super();
    this.descriptionFull = this.innerHTML;

    if (this.getAttribute("show-more") === "false") {
      this.SHOW_MORE = false;
    }

    if (this.getAttribute("max-length")) {
      this.MAX_LENGTH = parseInt(this.getAttribute("max-length"));
    }

    if (this.innerText.length > this.MAX_LENGTH) {
      // truncate text
      this.descriptionClipped = window.textClipper(
        this.descriptionFull,
        this.MAX_LENGTH,
        {
          html: true,
          indicator:
            `... <a class="readmore" href="${this.showMoreHref}">Voir plus&gt;</a>`,
        }
      );

      // replace original content with cropped desc
      this.innerHTML = this.descriptionClipped;

      // remove processing class
      this.classList.remove("processing");

      // move original description to bottom
      if (this.SHOW_MORE) {
        const bottomDescContainer = document.getElementById("full-description");

        bottomDescContainer.innerHTML = this.descriptionFull;
      }
    }
  }
  get showMoreHref(){
    return this.getAttribute('show-more-href') || '#full-description';
  }
}

customElements.define("collection-description", CollectionDescription);
